<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 12 14">    
    <path d="M10.25 6.977c0-0.852-0.25-1.641-0.68-2.305l-5.891 5.883c0.672 0.438 1.469 0.695 2.32 0.695 2.344 0 4.25-1.914 4.25-4.273zM2.445 9.313l5.898-5.891c-0.672-0.453-1.477-0.711-2.344-0.711-2.344 0-4.25 1.914-4.25 4.266 0 0.867 0.258 1.664 0.695 2.336zM12 6.977c0 3.328-2.687 6.023-6 6.023s-6-2.695-6-6.023c0-3.32 2.687-6.016 6-6.016s6 2.695 6 6.016z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-ban.html